import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { findDOMNode } from 'react-dom'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import { CirclePicker } from 'react-color'
import Popover from '@material-ui/core/Popover'
import Button from '@material-ui/core/Button'
import { ColorLens } from '@material-ui/icons'
import * as material from 'material-colors'
const styles = theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'inherit',
    cursor: 'pointer',
    // For correct alignment with the text.
    verticalAlign: 'middle',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    marginLeft: 0,
    marginRight: theme.spacing.unit * 2 // used for row presentation of radio/checkbox
  },
  disabled: {
    color: theme.palette.text.disabled,
    cursor: 'default'
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120
  },
  button: {
    marginRight: theme.spacing.unit * 2
  },
  label: {
    flexGrow: 2
  }
})

const defaultColors = [
  material.red['500'],
  material.pink['500'],
  material.purple['500'],
  material.deepPurple['500'],
  material.indigo['500'],
  material.blue['500'],
  material.lightBlue['500'],
  material.cyan['500'],
  material.teal['500'],
  material.green['500'],
  material.lightGreen['500'],
  material.lime['500'],
  material.yellow['500'],
  material.amber['500'],
  material.orange['500'],
  material.deepOrange['500'],
  material.brown['500'],
  material.blueGrey['500']
]
class ColorPickerComponent extends React.Component {
  state = {
    color: '',
    openColor: false,
    anchorEl: null,
    anchorReference: 'anchorEl'
  }

  static defaultProps = {
    color: defaultColors[Math.floor(Math.random() * defaultColors.length - 1)],
    disabled: false
  }
  componentDidMount() {
    if (this.props.color === void 0 || this.props.color === '') {
      const color =
        defaultColors[Math.floor(Math.random() * defaultColors.length - 1)]
      this.props.colorValidate(color)
    }
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.color !== void 0) {
      this.setState({ color: nextProps.color })
    }
  }

  handleClickButton = () => {
    this.setState({
      openColor: true,
      anchorEl: findDOMNode(this.button)
    })
  }
  handleChangeColorComplete = color => {
    this.setState({ color: color.hex, openColor: false })
    this.props.colorValidate(color.hex)
  }
  handleClose = e => {
    this.setState({ openColor: false })
  }
  render() {
    const { classes, disabled } = this.props
    const className = classNames(classes.root, {
      [classes.disabled]: disabled
    })
    const { color, openColor, anchorEl, anchorReference } = this.state
    return (
      <label className={className}>
        <Button
          ref={node => {
            this.button = node
          }}
          id="colorBtn"
          variant="fab"
          mini
          disabled={disabled}
          style={{ backgroung: color, color: color }}
          className={classes.button}
          onClick={this.handleClickButton}>
          <ColorLens color="inherit" />
        </Button>
        <Typography variant="body1" style={{ color: color }} align="center">
          Couleur
        </Typography>
        <Popover
          open={openColor}
          style={{ padding: 5 }}
          anchorEl={anchorEl}
          anchorReference={anchorReference}
          anchorPosition={{ top: 0, left: 0 }}
          onClose={this.handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
          <div style={{ padding: 10 }}>
            <CirclePicker
              id="color"
              color={color}
              onChangeComplete={this.handleChangeColorComplete}
            />
          </div>
        </Popover>
      </label>
    )
  }
}

ColorPickerComponent.propTypes = {
  classes: PropTypes.object.isRequired,
  colorValidate: PropTypes.func.isRequired,
  color: PropTypes.string,
  disabled: PropTypes.bool
}

export default withStyles(styles)(ColorPickerComponent)



// WEBPACK FOOTER //
// ./src/routes/Admin/components/CommonComponents/ColorPickerComponent.js